<template>
  <div class="overall-static u-flex-column">
    <div class="overall-static__form">
      <el-form :size="'small'" :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="统计时间">
          <el-date-picker
            style="width: 360px"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="time"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item label="快捷选择">
          <el-radio-group v-model="quickDays" @change="handleQuickDays">
            <el-radio-button :label="1">1天</el-radio-button>
            <el-radio-button :label="3">3天</el-radio-button>
            <el-radio-button :label="7">7天</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="进/出场">
          <el-select v-model="queryForm.inOutFlag" style="width: 110px">
            <el-option label="进场" :value="1" />
            <el-option label="出场" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="种类">
          <el-select
            v-model="queryForm.categoryTypes"
            multiple
            collapse-tags
            placeholder="请选择"
            style="width: 260px"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">统计</el-button>
          <download-excel
            :data="tableRows"
            :fields="exportFields"
            type="xls"
            worksheet="综合统计"
            :name="exportFileName"
          >
            <el-button type="success" icon="el-icon-download" :disabled="!tableRows.length">导出</el-button>
          </download-excel>
        </el-form-item>
      </el-form>
    </div>
    <div class="u-text-center overall-static__title">
      {{ barData.name }}{{ inOutFlagName }}统计
    </div>
    <div class="overall-static__chart">
      <bar-echart :chart-data="barData" :key="eckey"></bar-echart>
    </div>
    <div class="overall-static__table">
      <statistic-detail-table
        :dates="tableDates"
        :rows="tableRows"
        show-total-column
        merge-grand-total-row
      />
    </div>
  </div>
</template>

<script>
import BarEchart from "@/components/echarts/barEchart.vue";
import StatisticDetailTable from "@/components/echarts/StatisticDetailTable.vue";
import { setTime } from "@/commons/util.js";

export default {
  name: "OverallStatic",
  components: {
    BarEchart,
    StatisticDetailTable
  },
  data() {
    return {
      eckey: "",
      quickDays: 7,
      time: setTime(6),
      queryForm: {
        inOutFlag: 1,
        categoryTypes: [3, 2, 1, 4, 5]
      },
      categoryOptions: [
        { label: "大货车", value: 3, color: "#3ddc97" },
        { label: "客车", value: 2, color: "#4dabf7" },
        { label: "小轿车", value: 1, color: "#ffd166" },
        { label: "危化品车", value: 4, color: "#f25f5c" },
        { label: "行人", value: 5, color: "#b388ff" }
      ],
      tableDates: [],
      tableRows: [],
      exportFields: {
        类别名称: "category"
      },
      barData: {
        name: "综合",
        xvalue: [],
        series: [],
        colors: ["#3ddc97", "#4dabf7", "#ffd166", "#f25f5c", "#b388ff"]
      }
    };
  },
  computed: {
    inOutFlagName() {
      return this.queryForm.inOutFlag === 2 ? "出场" : "进场";
    },
    exportFileName() {
      return `综合${this.inOutFlagName}统计.xls`;
    }
  },
  methods: {
    handleQuickDays(days) {
      this.time = setTime(days - 1);
    },
    getColor(typeCode, index) {
      const option = this.categoryOptions.find(item => item.value === typeCode);
      return option ? option.color : this.barData.colors[index % this.barData.colors.length];
    },
    getCategoryName(item) {
      const option = this.categoryOptions.find(option => option.value === item.typeCode);
      return item.name || (option ? option.label : "");
    },
    buildRows(dates, series) {
      const subtotalRow = {
        categoryName: '\u5c0f\u8ba1',
        category: '\u5c0f\u8ba1',
        rowType: 'subtotal',
        total: 0
      };
      const totalRow = {
        categoryName: '\u603b\u8ba1',
        category: '\u603b\u8ba1',
        rowType: 'grandTotal',
        total: 0
      };
      const rows = series.map(item => {
        const categoryName = this.getCategoryName(item);
        const row = {
          categoryName,
          category: categoryName,
          total: 0
        };
        dates.forEach((date, index) => {
          const key = String(date);
          const value = item.data && item.data[index] != null ? Number(item.data[index]) : 0;
          row[key] = value;
          row.total += value;
          subtotalRow[key] = (subtotalRow[key] || 0) + value;
          subtotalRow.total += value;
        });
        return row;
      });
      totalRow.total = subtotalRow.total;
      dates.forEach(date => {
        const key = String(date);
        if (totalRow[key] == null) {
          totalRow[key] = "";
        }
      });
      return rows.concat([subtotalRow, totalRow]);
    },
    buildExportFields(dates) {
      const fields = {
        类别名称: "category"
      };
      dates.forEach(date => {
        const key = String(date);
        fields[key] = key;
      });
      fields['\u5408\u8ba1'] = 'total';
      this.exportFields = fields;
    },
    getData() {
      const data = {
        beginTime: this.time[0],
        endTime: this.time[1],
        inOutFlag: this.queryForm.inOutFlag,
        categoryTypes: this.queryForm.categoryTypes
      };
      this.$http.POST_overallInOutStatistic(data).then(res => {
        const result = res.data || {};
        const dates = result.statisticKey || [];
        const series = (result.series || []).map((item, index) => {
          return Object.assign({}, item, {
            color: this.getColor(item.typeCode, index)
          });
        });
        this.tableDates = dates;
        this.tableRows = this.buildRows(dates, series);
        this.buildExportFields(dates);
        this.barData = {
          name: "综合",
          xvalue: dates,
          series,
          colors: this.categoryOptions.map(item => item.color)
        };
        this.eckey = new Date().getTime();
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss">
.overall-static {
  height: 100%;
  display: flex;
}

.overall-static__form {
  min-height: 130px;
  padding: 26px 40px 0 80px;
}

.overall-static__title {
  font-size: 0.22rem;
  color: #fff;
}

.overall-static__chart {
  flex: 1;
  min-height: 0;
}

.overall-static__table {
  height: 220px;
  padding: 12px 40px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/tjfx/overallStatic.vue